import { render } from "./EventCard.vue?vue&type=template&id=a9a15f20&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=a9a15f20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9a15f20"

export default script